class ReconciliationDelegate {
    setRows(rows) {
        this.setState({ rows });
    }
}

export default ReconciliationDelegate;
